// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom Styling for DoctorDashboard */

/* Container */
.custom-doctor-dashboard-container {
    /* background-color: var(--clr-primary-8);  */
    background-color: var(--clr-grey-10); 
    padding: 2rem;
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
    margin: 2rem;
    padding: 20px;
    /* max-width: 90%;  */
    border: 3px solid var(--clr-primary-3);
}

/* Calendar Container */
.doctor-calendar {
    background-color: var(--clr-white); 
    border-radius: var(--radius);
    padding: 1rem;
    box-shadow: var(--shadow-2); 
    overflow-x: auto; 
    max-width: 100%; 
    box-sizing: border-box; 
}

/* Ensure the calendar cells, including agenda, fit within the container */
.doctor-calendar .rbc-agenda-content {
    width: 100%; 
    overflow: hidden; 
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .doctor-calendar {
        padding: 0.5rem; 
    }

    .doctor-calendar .rbc-agenda-content {
        font-size: 0.9rem; 
    }
}


/* Heading */
h2 {
    font-size: 2rem;
    color: var(--clr-primary-1);
    text-align: center;
    margin-bottom: 1.5rem;
}

/* Legend Section */
.custom-legend {
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
    padding: 0 1rem;
  }
  
  .custom-legend p {
    display: flex;
    align-items: center;
    font-size: 0.95rem;
    color: var(--clr-grey-5);
    padding: 0.5rem 0.75rem;
    border: 1px solid var(--clr-grey-3);
    border-radius: 8px;
    background-color: #f9f9f9;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    transition: background-color 0.3s ease;
    min-width: 200px;
    justify-content: center;
    text-align: center;
  }
  
  .custom-legend p:hover {
    background-color: #f1f1f1;
  }
  
  .custom-legend p svg {
    margin-right: 0.5rem;
    min-width: 16px;
  }
  
  /* Responsive Adjustments */
  @media screen and (max-width: 768px) {
    .custom-legend {
      gap: 0.75rem;
      justify-content: flex-start;
    }
  
    .custom-legend p {
      font-size: 0.9rem;
      min-width: 100%;
      justify-content: flex-start;
    }
  }
  
/* Filters and Search */
.custom-dashboard-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
    width: 100%;
    box-sizing: border-box;
    flex-wrap: wrap;
    gap: 1rem;
  }
  
  /* Pills Layout for Filters */
  .custom-filter-pills {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-start;
  }
  
  /* Individual Filter Button */
  .custom-pill-button {
    background-color: var(--clr-primary-5);
    border: none;
    color: var(--clr-white);
    padding: 0.5rem 1rem;
    border-radius: 50px;
    cursor: pointer;
    font-size: 0.85rem;
    white-space: nowrap;
    transition: background-color 0.3s ease;
  }
  
  .custom-pill-button:hover {
    background-color: var(--clr-primary-4);
  }
  
  .custom-pill-button.active {
    background-color: var(--clr-grey-3);
  }
  
  /* Responsive: Tablet and below */
  @media (max-width: 768px) {
    .custom-dashboard-controls {
      flex-direction: column;
      align-items: stretch;
      margin-bottom: 1.25rem;
    }
  
    .custom-filter-pills {
      justify-content: center;
    }
  
    .custom-pill-button {
      font-size: 0.85rem;
      padding: 0.45rem 0.9rem;
    }
  }
  
  /* Responsive: Mobile */
  @media (max-width: 480px) {
    .custom-dashboard-controls {
      margin-bottom: 1rem;
      gap: 0.75rem;
    }
  
    .custom-pill-button {
      font-size: 0.8rem;
      padding: 0.4rem 0.75rem;
    }
  }
  
/* Search Bar */
.custom-search-bar {
    margin-left: 1rem; 
    display: flex;
    align-items: center;
}

.custom-search-bar input {
    padding: 0.75rem 1.5rem;
    border: 1px solid var(--grey-300);
    border-radius: var(--radius);
    width: 250px; 
    outline: none;
    transition: border-color var(--transition);
    font-size: 1rem;
}

.custom-search-bar input:focus {
    border-color: var(--clr-primary-6);
}

/* View Toggle */
.custom-view-toggle {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
}

.custom-view-button {
    background-color: var(--clr-primary-4);
    color: var(--clr-white);
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    margin: 0 0.5rem;
    transition: background-color var(--transition);
}

.custom-view-button.active {
    background-color: var(--clr-grey-3);
}

/* Calendar Event Styles */
.rbc-event {
    border-radius: var(--radius);
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--clr-white);
    font-size: 0.9rem;
    animation: bounceIn 0.5s ease-in-out;
}

.rbc-event span svg {
    margin-right: 0.5rem;
}

/* Event Colors and Gradients */
.rbc-event.booked {
    background-image: linear-gradient(135deg, var(--clr-primary-5), var(--clr-primary-6));
}

.rbc-event.edited {
    background-image: linear-gradient(135deg, var(--clr-primary-3), var(--clr-primary-4));
}

.rbc-event.deleted {
    background-image: linear-gradient(135deg, var(--grey-400), var(--grey-500));
}

/* Bounce Animation */
@keyframes bounceIn {
    0% {
        transform: scale(0.9);
        opacity: 0.7;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

/* List View */
.custom-event-list {
    list-style: none;
    padding: 0;
}

.custom-event-list-item {
    background-color: var(--clr-grey-9);
    padding: 1rem;
    border-radius: var(--radius);
    margin-bottom: 1rem;
    box-shadow: var(--shadow-1);
    cursor: pointer;
}

.custom-event-list-item p {
    margin: 0.5rem 0;
}

.custom-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.35rem 0.75rem;
    border-radius: 25px;
    font-size: 0.85rem;
    font-weight: 500;
    white-space: nowrap;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    color: white;
  }
  

.custom-status-badge.booked {
    background-color: var(--clr-primary-6);
    color: var(--clr-white);
}

.custom-status-badge.edited {
    background-color: var(--clr-primary-3);
    color: var(--clr-white);
}

.custom-status-badge.deleted {
    background-color: var(--grey-400);
    color: var(--clr-white);
}

/* Modal Styles */
.custom-appointment-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: var(--clr-white);
    padding: 2rem;
    border-radius: 15px;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    width: 90%; 
    max-width: 900px;
    max-height: 90vh; 
    overflow-y: auto; 
    opacity: 0; 
    animation: fadeInSlideIn 0.4s ease-in-out forwards; 
}

/* Updated Keyframes */
@keyframes fadeInSlideIn {
    from {
        opacity: 0;
        transform: translate(-50%, -60%); 
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%); 
    }
}

/* Modal Content */
.custom-appointment-modal-content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1.5rem;
}

/* Modal Header */
.custom-appointment-modal-content h3 {
    font-size: 1.5rem; 
    font-weight: 600;
    text-align: center;
    color: var(--clr-primary-6);
    letter-spacing: 0.05em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid var(--clr-grey-10);
    padding-bottom: 0.5rem;
}

/* Download icon next to the header */
.custom-download-icon {
    font-size: 1.2rem;
    cursor: pointer;
    transition: color 0.3s ease;
}

.custom-download-icon:hover {
    color: var(--clr-primary-5); 
}

/* Updated Section Layout for Desktop (One After Another) */
.custom-modal-sections {
    display: flex;
    flex-direction: column; 
    gap: 2rem; 
    border: 1px solid var(--clr-primary-7); 
    border-radius: 10px; 
    padding: 1.5rem;
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.05); 
    background-color: var(--clr-white); 
}

/* Section Styles with Stylish Borders */
.custom-left-section, .custom-right-section {
    padding: 1.5rem;
    border-radius: 10px; 
    border: 1px solid var(--clr-primary-4); 
    background-color: var(--clr-grey-10);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.custom-left-section:hover, .custom-right-section:hover {
    transform: translateY(-5px); 
    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.1); 
}

/* Section Headings */
.custom-appointment-section h4, 
.custom-intake-form-section h4, 
.custom-doctor-notes-section h4, 
.custom-additional-details h4 {
    font-size: 1.1rem;
    font-weight: 500;
    color: var(--clr-primary-5);
    border-bottom: 2px solid var(--clr-primary-4);
    padding-bottom: 0.5rem;
    text-transform: uppercase;
}

/* Paragraph styling for section details */
.custom-appointment-section p,
.custom-intake-form-section p {
    font-size: 1.1rem;
    margin-bottom: 0.75rem;
    color: var(--clr-grey-3);
}

/* Textarea styles */
textarea {
    width: 100%;
    height: 80px;
    border: 1px solid var(--clr-grey-3);
    border-radius: 8px;
    padding: 1rem;
    font-size: 1rem;
    resize: vertical;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

textarea:focus {
    border-color: var(--clr-primary-5);
    outline: none;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1); 
}

/* Modal Actions Styling */
.custom-modal-actions {
    display: flex;
    /* justify-content: space-between; */
    gap: 1rem;
    margin-top: 1.5rem;
}

.doctor-dashboard-btn {
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    border: none;
    font-size: small;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
}

.doctor-dashboard-btn:hover {
    transform: scale(1.05); 
}

/* Save and Complete buttons */
.custom-save-btn, .custom-complete-btn {
    background-color: var(--clr-primary-6);
    color: var(--clr-white);
}

.custom-save-btn:hover, .custom-complete-btn:hover {
    background-color: var(--clr-primary-4);
}

/* Close button */
.custom-close-btn {
    background-color: var(--clr-grey-6);
    color: var(--clr-white);
}

.custom-close-btn:hover {
    background-color: var(--clr-grey-5);
}

/* Responsive Styling */
@media (max-width: 768px) {
    .custom-modal-sections {
        flex-direction: column; 
        gap: 1.5rem;
    }

    .custom-appointment-modal {
        padding: 1.5rem;
        width: 95%; 
        max-width: 95%; 
        max-height: 90vh; 
        overflow-y: auto; 
    }

    /* Make sure modal content scales properly */
    .custom-appointment-modal-content {
        font-size: 0.9rem;
    }
}

@media (max-width: 480px) {
    .custom-appointment-modal {
        padding: 1rem;
        width: 98%; 
        max-width: 100%; 
        max-height: 85vh; 
    }

    .custom-modal-sections {
        flex-direction: column;
        gap: 1rem;
    }
}

/* Responsive Adjustments for Buttons */
@media (max-width: 768px) {
    .custom-modal-actions {
        flex-direction: column; 
        align-items: stretch; 
    }

    .doctor-dashboard-btn {
        width: 100%; 
        font-size: 0.9rem; 
    }

    /* button + button {
        margin-top: 0.75rem; 
    } */
}

/* Override the white-space: nowrap for .rbc-btn-group */
.rbc-btn-group {
    white-space: normal !important; /* Force normal white-space behavior to allow wrapping */
}

/* Email Modal Container */
.custom-email-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: var(--clr-white);
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    z-index: 1100;
    width: 90%;
    max-width: 500px;
    animation: fadeIn 0.4s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translate(-50%, -60%);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
}

/* Modal Content */
.custom-email-modal-content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

/* Modal Heading */
.custom-email-modal-content h3 {
    font-size: 1.8rem;
    font-weight: 600;
    text-align: center;
    color: var(--clr-primary-6);
    margin-bottom: 1rem;
}

/* Input Field */
.custom-email-modal-content input[type="email"] {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid var(--grey-300);
    border-radius: 8px;
    font-size: 1rem;
    outline: none;
    transition: border-color 0.3s ease;
}

.custom-email-modal-content input[type="email"]:focus {
    border-color: var(--clr-primary-5);
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
}

/* Action Buttons */
.custom-email-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
}

.custom-email-modal-actions button {
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
}

.custom-email-modal-actions button:hover {
    transform: scale(1.05);
}

/* Send Button */
.custom-email-modal-actions button:first-child {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
}

.custom-email-modal-actions button:first-child:hover {
    background-color: var(--clr-primary-4);
}

/* Cancel Button */
.custom-email-modal-actions button:last-child {
    background-color: var(--grey-300);
    color: var(--grey-700);
}

.custom-email-modal-actions button:last-child:hover {
    background-color: var(--grey-400);
}


/* Responsive Styling */
@media (max-width: 768px) {
    .custom-email-modal {
        width: 95%;
        max-width: 400px;
        padding: 1.5rem;
    }

    .custom-email-modal-content h3 {
        font-size: 1.5rem;
    }

    .custom-email-modal-content input[type="email"] {
        font-size: 0.95rem;
        padding: 0.65rem;
    }

    .custom-email-modal-actions button {
        padding: 0.6rem 1.2rem;
        font-size: 0.9rem;
    }
}

@media (max-width: 480px) {
    .custom-email-modal {
        width: 95%;
        padding: 1rem;
    }

    .custom-email-modal-content h3 {
        font-size: 1.3rem;
    }

    .custom-email-modal-content input[type="email"] {
        font-size: 0.9rem;
        padding: 0.6rem;
    }

    .custom-email-modal-actions button {
        padding: 0.5rem 1rem;
        font-size: 0.85rem;
    }
}

/* Signature Section */
.custom-signature-section {
    margin-top: 2rem;
    padding: 1.5rem;
    background-color: var(--grey-100);
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    gap: 1rem;
}

.custom-signature-section h4 {
    font-size: 1rem;
    font-weight: 500;
    color: var(--clr-primary-5);
    margin-bottom: 1rem;
}

/* Signature Type Radio Buttons */
.custom-signature-section label {
    margin-right: 1rem;
    font-size: 1rem;
    color: var(--grey-700);
    cursor: pointer;
}

.custom-signature-section label input {
    margin-right: 0.5rem;
}

/* Typed Signature Input */
.custom-signature-input {
    /* width: 250px; */
    padding: 0.5rem;
    font-size: 1rem;
    border: 1px solid var(--grey-300);
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
    outline: none;
    transition: border-color 0.3s ease;
}

.custom-signature-input:focus {
    border-color: var(--clr-primary-5);
}

/* Signature Canvas Styling */
.signature-canvas {
    border: 2px solid var(--grey-300);
    border-radius: var(--radius);
    width: 270px; 
    height: 150px; 
    box-shadow: var(--shadow-2);
    cursor: crosshair; 
    touch-action: none;
}

/* Clear Signature Button */
.custom-signature-section button {
    padding: 0.5rem 1rem;
    border-radius: var(--radius);
    background-color: var(--clr-primary-6);
    color: var(--clr-white);
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.custom-signature-section button:hover {
    background-color: var(--clr-primary-4);
    transform: scale(1.05);
}

/* Responsive Styles */
@media (max-width: 768px) {
    .signature-canvas {
        width: 200px;
        height: 120px;
    }

    .custom-signature-section h4 {
        font-size: 1.3rem;
    }

    .custom-signature-section button {
        padding: 0.5rem;
        font-size: 0.9rem;
    }
}

/* Styles for the container of the empty state */
.custom-empty-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px; 
    background-color: var(--clr-light-grey); 
    border-radius: var(--radius);
    box-shadow: var(--light-shadow); 
  }
  
  /* Styles for the message box */
  .custom-empty-message-box {
    padding: 2rem; 
    text-align: center;
    max-width: 400px; 
    background-color: var(--clr-white); 
    border-radius: var(--radius); 
  }
  
  /* Styles for the empty message text */
  .custom-empty-message {
    font-size: 1.2rem; 
    color: var(--clr-grey-4); 
    font-style: italic; 
    margin: 0; 
    line-height: 1.5; 
  }
  

  .custom-view-details-btn {
    padding: 0.5rem 1rem;
    background-color: var(--clr-primary-5);
    color: white;
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 1rem;
  }
  
  .custom-view-details-btn:hover {
    background-color: var(--clr-primary-3);
    transform: translateY(-2px);
  }
  
/* Close Icon Container */
.custom-close-icon-container {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background-color: var(--grey-400); 
    border-radius: 50%; 
    width: 40px; 
    height: 40px; 
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); 
}

/* Icon itself */
.custom-close-icon {
    font-size: 1.5rem;
    color: var(--clr-grey-5); /* Icon color */
    transition: color 0.3s ease-in-out, transform 0.3s ease-in-out;
}

/* Hover Effect */
.custom-close-icon-container:hover {
    background-color: var(--clr-primary-3); 
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15); 
}

.custom-close-icon-container:hover .custom-close-icon {
    color: var(--clr-white); 
    transform: rotate(90deg); 
}

.textarea-wrapper {
    display: flex;
    align-items: center; 
    gap: 10px; 
}

.textarea-wrapper textarea {
    width: 100%; 
    height: 80px;
    border: 1px solid var(--clr-grey-3);
    border-radius: 8px;
    padding: 1rem;
    font-size: 1rem;
    resize: vertical;
}

.textarea-wrapper .mic-button {
    cursor: pointer;
    background: none;
    border: none;
    font-size: 1.2rem; 
    padding: 0; 
}

.textarea-wrapper .mic-button.listening {
    color: #ff5722; 
}

.textarea-wrapper .mic-button.stop-button {
    color: #F44336; 
}

.textarea-wrapper .mic-button.disabled-mic {
    color: #b0b0b0; 
    cursor: not-allowed;
}

/* Ensure the icon buttons are vertically centered */
.mic-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%; 
}

/* Status-specific overrides */
.custom-status-badge.BO {
    background: linear-gradient(135deg, #e07a5f, #b95441); /* Coral-Orange */
    color: white;
  }
  
  .custom-status-badge.AP {
    background: linear-gradient(135deg, #fdd835, #fbc02d); /* Amber */
    color: #2c2c2c;
  }
  
  .custom-status-badge.PW {
    background: linear-gradient(135deg, #42a5f5, #1e88e5); /* Blue */
    color: white;
  }
  
  .custom-status-badge.CO {
    background: linear-gradient(135deg, #66bb6a, #43a047); /* Green */
    color: white;
  }
  
  .custom-status-badge.CA {
    background: linear-gradient(135deg, #ef5350, #e53935); /* Red */
    color: white;
  }
  
  .custom-status-badge.PC {
    background: linear-gradient(135deg, #7e57c2, #5e35b1); /* Purple */
    color: white;
  }
  
  @media (max-width: 480px) {
    .custom-status-badge {
      font-size: 0.75rem;
      padding: 0.3rem 0.6rem;
    }
  }
  
.error-message-complete {
    color: red;
    font-size: 12px;
    margin-top: 4px;
  }
  
  .error-border {
    border: 2px solid red !important;
  }

  .intake-form-info-wrapper {
    margin-top: 1.5rem;
    padding: 1rem;
    background-color: var(--clr-grey-10);
    border: 1px solid var(--clr-grey-5);
    border-radius: 8px;
    text-align: center;
  }
  
  .intake-form-info-text {
    font-size: 1rem;
    color: var(--clr-grey-3);
    margin-bottom: 0.75rem;
  }
  
  .custom-intake-form-btn {
    padding: 0.6rem 1.2rem;
    background-color: var(--clr-primary-6);
    color: #fff;
    border: none;
    border-radius: 5px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .custom-intake-form-btn:hover {
    background-color: var(--clr-primary-7);
  }
  

  .summary-section-wrapper {
    margin-top: 1.5rem;
    padding: 1rem;
    border: 1px solid var(--clr-primary-4);
    border-radius: 8px;
    background-color: var(--clr-grey-10);
    font-size: 0.95rem;
  }
  
  .summary-title {
    margin-bottom: 0.75rem;
    font-size: 1rem;
    font-weight: 600;
    color: var(--clr-grey-1, #333);
  }
  
  .summary-field {
    margin-bottom: 0.75rem;
  }
  
  .summary-input,
  .summary-textarea {
    width: 100%;
    font-size: 0.9rem;
    padding: 0.4rem 0.6rem;
    border: 1px solid var(--clr-grey-3);
    border-radius: 6px;
    resize: vertical;
    background-color: white;
  }
  
  .summary-textarea {
    min-height: 60px;
  }
  
  .room-highlight-badge {
    background-color: #fdd835; /* Amber yellow */
    color: #000; /* Dark text for contrast */
    padding: 2px 8px;
    border-radius: 8px;
    font-weight: bold;
    display: inline-block;
    margin-left: 4px;
  }
  
  .timeline-cta-box {
    margin-top: 1rem;
    background-color: var(--clr-primary-9);
    padding: 0.75rem 1rem;
    border-radius: var(--radius);
    border: 1px solid var(--clr-grey-8);
  }
  
  .timeline-cta-text {
    font-size: 0.95rem;
    color: var(--clr-grey-1);
  }
  
  .timeline-cta-link {
    color: var(--clr-primary-7);
    font-weight: bold;
    cursor: pointer;
    text-decoration: underline;
  }`, "",{"version":3,"sources":["webpack://./src/components/Scheduling/styles/DoctorDashboard.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC,cAAc;AACd;IACI,6CAA6C;IAC7C,oCAAoC;IACpC,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA,uBAAuB;AACvB;IACI,kCAAkC;IAClC,4BAA4B;IAC5B,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;AAEA,0EAA0E;AAC1E;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;;AAGA,YAAY;AACZ;IACI,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,uBAAuB;IACvB,mCAAmC;IACnC,kBAAkB;IAClB,yBAAyB;IACzB,yCAAyC;IACzC,sCAAsC;IACtC,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA,2BAA2B;EAC3B;IACE;MACE,YAAY;MACZ,2BAA2B;IAC7B;;IAEA;MACE,iBAAiB;MACjB,eAAe;MACf,2BAA2B;IAC7B;EACF;;AAEF,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,SAAS;EACX;;EAEA,6BAA6B;EAC7B;IACE,aAAa;IACb,WAAW;IACX,eAAe;IACf,WAAW;IACX,2BAA2B;EAC7B;;EAEA,6BAA6B;EAC7B;IACE,sCAAsC;IACtC,YAAY;IACZ,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,mCAAmC;EACrC;;EAEA,iCAAiC;EACjC;IACE;MACE,sBAAsB;MACtB,oBAAoB;MACpB,sBAAsB;IACxB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,kBAAkB;MAClB,uBAAuB;IACzB;EACF;;EAEA,uBAAuB;EACvB;IACE;MACE,mBAAmB;MACnB,YAAY;IACd;;IAEA;MACE,iBAAiB;MACjB,uBAAuB;IACzB;EACF;;AAEF,eAAe;AACf;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,iCAAiC;IACjC,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;AACvC;;AAEA,0BAA0B;AAC1B;IACI,4BAA4B;IAC5B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;AACxB;;AAEA,+BAA+B;AAC/B;IACI,qFAAqF;AACzF;;AAEA;IACI,qFAAqF;AACzF;;AAEA;IACI,2EAA2E;AAC/E;;AAEA,qBAAqB;AACrB;IACI;QACI,qBAAqB;QACrB,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA,cAAc;AACd;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qCAAqC;IACrC,YAAY;EACd;;;AAGF;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,6CAA6C;IAC7C,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,kDAAkD;AACtD;;AAEA,sBAAsB;AACtB;IACI;QACI,UAAU;QACV,gCAAgC;IACpC;IACA;QACI,UAAU;QACV,gCAAgC;IACpC;AACJ;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA,qCAAqC;AACrC;IACI,iBAAiB;IACjB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,2DAA2D;AAC3D;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sCAAsC;IACtC,mBAAmB;IACnB,eAAe;IACf,4CAA4C;IAC5C,kCAAkC;AACtC;;AAEA,wCAAwC;AACxC;IACI,eAAe;IACf,mBAAmB;IACnB,sCAAsC;IACtC,oCAAoC;IACpC,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA,qBAAqB;AACrB;;;;IAII,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,6CAA6C;IAC7C,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA,0CAA0C;AAC1C;;IAEI,iBAAiB;IACjB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA;IACI,kCAAkC;IAClC,aAAa;IACb,0CAA0C;AAC9C;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,oCAAoC;IACpC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,8BAA8B;AAC9B;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,iBAAiB;AACjB;IACI,mCAAmC;IACnC,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;AACvC;;AAEA,uBAAuB;AACvB;IACI;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,eAAe;QACf,UAAU;QACV,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA,4CAA4C;IAC5C;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,UAAU;QACV,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ;;AAEA,uCAAuC;AACvC;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;;OAEG;AACP;;AAEA,wDAAwD;AACxD;IACI,8BAA8B,EAAE,wDAAwD;AAC5F;;AAEA,0BAA0B;AAC1B;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI;QACI,UAAU;QACV,gCAAgC;IACpC;IACA;QACI,UAAU;QACV,gCAAgC;IACpC;AACJ;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,sCAAsC;AAC1C;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,gBAAgB;AAChB;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,kBAAkB;AAClB;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;;AAGA,uBAAuB;AACvB;IACI;QACI,UAAU;QACV,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;IACtB;AACJ;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,4BAA4B;IAC5B,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,4BAA4B;IAC5B,2BAA2B;IAC3B,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA,6BAA6B;AAC7B;IACI,iCAAiC;IACjC,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,2BAA2B;AAC3B;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,sCAAsC;IACtC,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA,sBAAsB;AACtB;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA,gDAAgD;AAChD;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,uCAAuC;IACvC,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA,+BAA+B;EAC/B;IACE,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,4BAA4B;EAC9B;;EAEA,sCAAsC;EACtC;IACE,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;EAClB;;;EAGA;IACE,oBAAoB;IACpB,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,sCAAsC;IACtC,2BAA2B;EAC7B;;AAEF,yBAAyB;AACzB;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iCAAiC;IACjC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,0CAA0C;AAC9C;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,wBAAwB,EAAE,eAAe;IACzC,8DAA8D;AAClE;;AAEA,iBAAiB;AACjB;IACI,sCAAsC;IACtC,4CAA4C;AAChD;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,oDAAoD;AACpD;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA,8BAA8B;AAC9B;IACI,qDAAqD,EAAE,iBAAiB;IACxE,YAAY;EACd;;EAEA;IACE,qDAAqD,EAAE,UAAU;IACjE,cAAc;EAChB;;EAEA;IACE,qDAAqD,EAAE,SAAS;IAChE,YAAY;EACd;;EAEA;IACE,qDAAqD,EAAE,UAAU;IACjE,YAAY;EACd;;EAEA;IACE,qDAAqD,EAAE,QAAQ;IAC/D,YAAY;EACd;;EAEA;IACE,qDAAqD,EAAE,WAAW;IAClE,YAAY;EACd;;EAEA;IACE;MACE,kBAAkB;MAClB,sBAAsB;IACxB;EACF;;AAEF;IACI,UAAU;IACV,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;EACxC;;;EAGA;IACE,kBAAkB;IAClB,aAAa;IACb,sCAAsC;IACtC,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB,EAAE,iBAAiB;IAC5C,WAAW,EAAE,2BAA2B;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;IACtC,qBAAqB;IACrB,4BAA4B;IAC5B,mCAAmC;EACrC;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;IACf,0BAA0B;EAC5B","sourcesContent":["/* Custom Styling for DoctorDashboard */\n\n/* Container */\n.custom-doctor-dashboard-container {\n    /* background-color: var(--clr-primary-8);  */\n    background-color: var(--clr-grey-10); \n    padding: 2rem;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n    margin: 2rem;\n    padding: 20px;\n    /* max-width: 90%;  */\n    border: 3px solid var(--clr-primary-3);\n}\n\n/* Calendar Container */\n.doctor-calendar {\n    background-color: var(--clr-white); \n    border-radius: var(--radius);\n    padding: 1rem;\n    box-shadow: var(--shadow-2); \n    overflow-x: auto; \n    max-width: 100%; \n    box-sizing: border-box; \n}\n\n/* Ensure the calendar cells, including agenda, fit within the container */\n.doctor-calendar .rbc-agenda-content {\n    width: 100%; \n    overflow: hidden; \n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .doctor-calendar {\n        padding: 0.5rem; \n    }\n\n    .doctor-calendar .rbc-agenda-content {\n        font-size: 0.9rem; \n    }\n}\n\n\n/* Heading */\nh2 {\n    font-size: 2rem;\n    color: var(--clr-primary-1);\n    text-align: center;\n    margin-bottom: 1.5rem;\n}\n\n/* Legend Section */\n.custom-legend {\n    display: flex;\n    justify-content: center;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n    flex-wrap: wrap;\n    padding: 0 1rem;\n  }\n  \n  .custom-legend p {\n    display: flex;\n    align-items: center;\n    font-size: 0.95rem;\n    color: var(--clr-grey-5);\n    padding: 0.5rem 0.75rem;\n    border: 1px solid var(--clr-grey-3);\n    border-radius: 8px;\n    background-color: #f9f9f9;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    transition: background-color 0.3s ease;\n    min-width: 200px;\n    justify-content: center;\n    text-align: center;\n  }\n  \n  .custom-legend p:hover {\n    background-color: #f1f1f1;\n  }\n  \n  .custom-legend p svg {\n    margin-right: 0.5rem;\n    min-width: 16px;\n  }\n  \n  /* Responsive Adjustments */\n  @media screen and (max-width: 768px) {\n    .custom-legend {\n      gap: 0.75rem;\n      justify-content: flex-start;\n    }\n  \n    .custom-legend p {\n      font-size: 0.9rem;\n      min-width: 100%;\n      justify-content: flex-start;\n    }\n  }\n  \n/* Filters and Search */\n.custom-dashboard-controls {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n    width: 100%;\n    box-sizing: border-box;\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n  \n  /* Pills Layout for Filters */\n  .custom-filter-pills {\n    display: flex;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    width: 100%;\n    justify-content: flex-start;\n  }\n  \n  /* Individual Filter Button */\n  .custom-pill-button {\n    background-color: var(--clr-primary-5);\n    border: none;\n    color: var(--clr-white);\n    padding: 0.5rem 1rem;\n    border-radius: 50px;\n    cursor: pointer;\n    font-size: 0.85rem;\n    white-space: nowrap;\n    transition: background-color 0.3s ease;\n  }\n  \n  .custom-pill-button:hover {\n    background-color: var(--clr-primary-4);\n  }\n  \n  .custom-pill-button.active {\n    background-color: var(--clr-grey-3);\n  }\n  \n  /* Responsive: Tablet and below */\n  @media (max-width: 768px) {\n    .custom-dashboard-controls {\n      flex-direction: column;\n      align-items: stretch;\n      margin-bottom: 1.25rem;\n    }\n  \n    .custom-filter-pills {\n      justify-content: center;\n    }\n  \n    .custom-pill-button {\n      font-size: 0.85rem;\n      padding: 0.45rem 0.9rem;\n    }\n  }\n  \n  /* Responsive: Mobile */\n  @media (max-width: 480px) {\n    .custom-dashboard-controls {\n      margin-bottom: 1rem;\n      gap: 0.75rem;\n    }\n  \n    .custom-pill-button {\n      font-size: 0.8rem;\n      padding: 0.4rem 0.75rem;\n    }\n  }\n  \n/* Search Bar */\n.custom-search-bar {\n    margin-left: 1rem; \n    display: flex;\n    align-items: center;\n}\n\n.custom-search-bar input {\n    padding: 0.75rem 1.5rem;\n    border: 1px solid var(--grey-300);\n    border-radius: var(--radius);\n    width: 250px; \n    outline: none;\n    transition: border-color var(--transition);\n    font-size: 1rem;\n}\n\n.custom-search-bar input:focus {\n    border-color: var(--clr-primary-6);\n}\n\n/* View Toggle */\n.custom-view-toggle {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 1rem;\n}\n\n.custom-view-button {\n    background-color: var(--clr-primary-4);\n    color: var(--clr-white);\n    padding: 0.75rem 1.5rem;\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    margin: 0 0.5rem;\n    transition: background-color var(--transition);\n}\n\n.custom-view-button.active {\n    background-color: var(--clr-grey-3);\n}\n\n/* Calendar Event Styles */\n.rbc-event {\n    border-radius: var(--radius);\n    padding: 0.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: var(--clr-white);\n    font-size: 0.9rem;\n    animation: bounceIn 0.5s ease-in-out;\n}\n\n.rbc-event span svg {\n    margin-right: 0.5rem;\n}\n\n/* Event Colors and Gradients */\n.rbc-event.booked {\n    background-image: linear-gradient(135deg, var(--clr-primary-5), var(--clr-primary-6));\n}\n\n.rbc-event.edited {\n    background-image: linear-gradient(135deg, var(--clr-primary-3), var(--clr-primary-4));\n}\n\n.rbc-event.deleted {\n    background-image: linear-gradient(135deg, var(--grey-400), var(--grey-500));\n}\n\n/* Bounce Animation */\n@keyframes bounceIn {\n    0% {\n        transform: scale(0.9);\n        opacity: 0.7;\n    }\n    100% {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n/* List View */\n.custom-event-list {\n    list-style: none;\n    padding: 0;\n}\n\n.custom-event-list-item {\n    background-color: var(--clr-grey-9);\n    padding: 1rem;\n    border-radius: var(--radius);\n    margin-bottom: 1rem;\n    box-shadow: var(--shadow-1);\n    cursor: pointer;\n}\n\n.custom-event-list-item p {\n    margin: 0.5rem 0;\n}\n\n.custom-status-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    padding: 0.35rem 0.75rem;\n    border-radius: 25px;\n    font-size: 0.85rem;\n    font-weight: 500;\n    white-space: nowrap;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    color: white;\n  }\n  \n\n.custom-status-badge.booked {\n    background-color: var(--clr-primary-6);\n    color: var(--clr-white);\n}\n\n.custom-status-badge.edited {\n    background-color: var(--clr-primary-3);\n    color: var(--clr-white);\n}\n\n.custom-status-badge.deleted {\n    background-color: var(--grey-400);\n    color: var(--clr-white);\n}\n\n/* Modal Styles */\n.custom-appointment-modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: var(--clr-white);\n    padding: 2rem;\n    border-radius: 15px;\n    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n    width: 90%; \n    max-width: 900px;\n    max-height: 90vh; \n    overflow-y: auto; \n    opacity: 0; \n    animation: fadeInSlideIn 0.4s ease-in-out forwards; \n}\n\n/* Updated Keyframes */\n@keyframes fadeInSlideIn {\n    from {\n        opacity: 0;\n        transform: translate(-50%, -60%); \n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%, -50%); \n    }\n}\n\n/* Modal Content */\n.custom-appointment-modal-content {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    padding: 1.5rem;\n}\n\n/* Modal Header */\n.custom-appointment-modal-content h3 {\n    font-size: 1.5rem; \n    font-weight: 600;\n    text-align: center;\n    color: var(--clr-primary-6);\n    letter-spacing: 0.05em;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 2px solid var(--clr-grey-10);\n    padding-bottom: 0.5rem;\n}\n\n/* Download icon next to the header */\n.custom-download-icon {\n    font-size: 1.2rem;\n    cursor: pointer;\n    transition: color 0.3s ease;\n}\n\n.custom-download-icon:hover {\n    color: var(--clr-primary-5); \n}\n\n/* Updated Section Layout for Desktop (One After Another) */\n.custom-modal-sections {\n    display: flex;\n    flex-direction: column; \n    gap: 2rem; \n    border: 1px solid var(--clr-primary-7); \n    border-radius: 10px; \n    padding: 1.5rem;\n    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.05); \n    background-color: var(--clr-white); \n}\n\n/* Section Styles with Stylish Borders */\n.custom-left-section, .custom-right-section {\n    padding: 1.5rem;\n    border-radius: 10px; \n    border: 1px solid var(--clr-primary-4); \n    background-color: var(--clr-grey-10);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.custom-left-section:hover, .custom-right-section:hover {\n    transform: translateY(-5px); \n    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.1); \n}\n\n/* Section Headings */\n.custom-appointment-section h4, \n.custom-intake-form-section h4, \n.custom-doctor-notes-section h4, \n.custom-additional-details h4 {\n    font-size: 1.1rem;\n    font-weight: 500;\n    color: var(--clr-primary-5);\n    border-bottom: 2px solid var(--clr-primary-4);\n    padding-bottom: 0.5rem;\n    text-transform: uppercase;\n}\n\n/* Paragraph styling for section details */\n.custom-appointment-section p,\n.custom-intake-form-section p {\n    font-size: 1.1rem;\n    margin-bottom: 0.75rem;\n    color: var(--clr-grey-3);\n}\n\n/* Textarea styles */\ntextarea {\n    width: 100%;\n    height: 80px;\n    border: 1px solid var(--clr-grey-3);\n    border-radius: 8px;\n    padding: 1rem;\n    font-size: 1rem;\n    resize: vertical;\n    transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\ntextarea:focus {\n    border-color: var(--clr-primary-5);\n    outline: none;\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1); \n}\n\n/* Modal Actions Styling */\n.custom-modal-actions {\n    display: flex;\n    /* justify-content: space-between; */\n    gap: 1rem;\n    margin-top: 1.5rem;\n}\n\n.doctor-dashboard-btn {\n    padding: 0.75rem 1.5rem;\n    border-radius: 8px;\n    border: none;\n    font-size: small;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s, transform 0.2s;\n}\n\n.doctor-dashboard-btn:hover {\n    transform: scale(1.05); \n}\n\n/* Save and Complete buttons */\n.custom-save-btn, .custom-complete-btn {\n    background-color: var(--clr-primary-6);\n    color: var(--clr-white);\n}\n\n.custom-save-btn:hover, .custom-complete-btn:hover {\n    background-color: var(--clr-primary-4);\n}\n\n/* Close button */\n.custom-close-btn {\n    background-color: var(--clr-grey-6);\n    color: var(--clr-white);\n}\n\n.custom-close-btn:hover {\n    background-color: var(--clr-grey-5);\n}\n\n/* Responsive Styling */\n@media (max-width: 768px) {\n    .custom-modal-sections {\n        flex-direction: column; \n        gap: 1.5rem;\n    }\n\n    .custom-appointment-modal {\n        padding: 1.5rem;\n        width: 95%; \n        max-width: 95%; \n        max-height: 90vh; \n        overflow-y: auto; \n    }\n\n    /* Make sure modal content scales properly */\n    .custom-appointment-modal-content {\n        font-size: 0.9rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .custom-appointment-modal {\n        padding: 1rem;\n        width: 98%; \n        max-width: 100%; \n        max-height: 85vh; \n    }\n\n    .custom-modal-sections {\n        flex-direction: column;\n        gap: 1rem;\n    }\n}\n\n/* Responsive Adjustments for Buttons */\n@media (max-width: 768px) {\n    .custom-modal-actions {\n        flex-direction: column; \n        align-items: stretch; \n    }\n\n    .doctor-dashboard-btn {\n        width: 100%; \n        font-size: 0.9rem; \n    }\n\n    /* button + button {\n        margin-top: 0.75rem; \n    } */\n}\n\n/* Override the white-space: nowrap for .rbc-btn-group */\n.rbc-btn-group {\n    white-space: normal !important; /* Force normal white-space behavior to allow wrapping */\n}\n\n/* Email Modal Container */\n.custom-email-modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: var(--clr-white);\n    padding: 2rem;\n    border-radius: 12px;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n    z-index: 1100;\n    width: 90%;\n    max-width: 500px;\n    animation: fadeIn 0.4s ease-in-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translate(-50%, -60%);\n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%, -50%);\n    }\n}\n\n/* Modal Content */\n.custom-email-modal-content {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n/* Modal Heading */\n.custom-email-modal-content h3 {\n    font-size: 1.8rem;\n    font-weight: 600;\n    text-align: center;\n    color: var(--clr-primary-6);\n    margin-bottom: 1rem;\n}\n\n/* Input Field */\n.custom-email-modal-content input[type=\"email\"] {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid var(--grey-300);\n    border-radius: 8px;\n    font-size: 1rem;\n    outline: none;\n    transition: border-color 0.3s ease;\n}\n\n.custom-email-modal-content input[type=\"email\"]:focus {\n    border-color: var(--clr-primary-5);\n    box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);\n}\n\n/* Action Buttons */\n.custom-email-modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n}\n\n.custom-email-modal-actions button {\n    padding: 0.75rem 1.5rem;\n    border: none;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s, transform 0.2s;\n}\n\n.custom-email-modal-actions button:hover {\n    transform: scale(1.05);\n}\n\n/* Send Button */\n.custom-email-modal-actions button:first-child {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n}\n\n.custom-email-modal-actions button:first-child:hover {\n    background-color: var(--clr-primary-4);\n}\n\n/* Cancel Button */\n.custom-email-modal-actions button:last-child {\n    background-color: var(--grey-300);\n    color: var(--grey-700);\n}\n\n.custom-email-modal-actions button:last-child:hover {\n    background-color: var(--grey-400);\n}\n\n\n/* Responsive Styling */\n@media (max-width: 768px) {\n    .custom-email-modal {\n        width: 95%;\n        max-width: 400px;\n        padding: 1.5rem;\n    }\n\n    .custom-email-modal-content h3 {\n        font-size: 1.5rem;\n    }\n\n    .custom-email-modal-content input[type=\"email\"] {\n        font-size: 0.95rem;\n        padding: 0.65rem;\n    }\n\n    .custom-email-modal-actions button {\n        padding: 0.6rem 1.2rem;\n        font-size: 0.9rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .custom-email-modal {\n        width: 95%;\n        padding: 1rem;\n    }\n\n    .custom-email-modal-content h3 {\n        font-size: 1.3rem;\n    }\n\n    .custom-email-modal-content input[type=\"email\"] {\n        font-size: 0.9rem;\n        padding: 0.6rem;\n    }\n\n    .custom-email-modal-actions button {\n        padding: 0.5rem 1rem;\n        font-size: 0.85rem;\n    }\n}\n\n/* Signature Section */\n.custom-signature-section {\n    margin-top: 2rem;\n    padding: 1.5rem;\n    background-color: var(--grey-100);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n    display: flex;\n    flex-direction: column;\n    /* align-items: center; */\n    gap: 1rem;\n}\n\n.custom-signature-section h4 {\n    font-size: 1rem;\n    font-weight: 500;\n    color: var(--clr-primary-5);\n    margin-bottom: 1rem;\n}\n\n/* Signature Type Radio Buttons */\n.custom-signature-section label {\n    margin-right: 1rem;\n    font-size: 1rem;\n    color: var(--grey-700);\n    cursor: pointer;\n}\n\n.custom-signature-section label input {\n    margin-right: 0.5rem;\n}\n\n/* Typed Signature Input */\n.custom-signature-input {\n    /* width: 250px; */\n    padding: 0.5rem;\n    font-size: 1rem;\n    border: 1px solid var(--grey-300);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n    outline: none;\n    transition: border-color 0.3s ease;\n}\n\n.custom-signature-input:focus {\n    border-color: var(--clr-primary-5);\n}\n\n/* Signature Canvas Styling */\n.signature-canvas {\n    border: 2px solid var(--grey-300);\n    border-radius: var(--radius);\n    width: 270px; \n    height: 150px; \n    box-shadow: var(--shadow-2);\n    cursor: crosshair; \n    touch-action: none;\n}\n\n/* Clear Signature Button */\n.custom-signature-section button {\n    padding: 0.5rem 1rem;\n    border-radius: var(--radius);\n    background-color: var(--clr-primary-6);\n    color: var(--clr-white);\n    border: none;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.custom-signature-section button:hover {\n    background-color: var(--clr-primary-4);\n    transform: scale(1.05);\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n    .signature-canvas {\n        width: 200px;\n        height: 120px;\n    }\n\n    .custom-signature-section h4 {\n        font-size: 1.3rem;\n    }\n\n    .custom-signature-section button {\n        padding: 0.5rem;\n        font-size: 0.9rem;\n    }\n}\n\n/* Styles for the container of the empty state */\n.custom-empty-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 150px; \n    background-color: var(--clr-light-grey); \n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow); \n  }\n  \n  /* Styles for the message box */\n  .custom-empty-message-box {\n    padding: 2rem; \n    text-align: center;\n    max-width: 400px; \n    background-color: var(--clr-white); \n    border-radius: var(--radius); \n  }\n  \n  /* Styles for the empty message text */\n  .custom-empty-message {\n    font-size: 1.2rem; \n    color: var(--clr-grey-4); \n    font-style: italic; \n    margin: 0; \n    line-height: 1.5; \n  }\n  \n\n  .custom-view-details-btn {\n    padding: 0.5rem 1rem;\n    background-color: var(--clr-primary-5);\n    color: white;\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: all 0.3s ease;\n    margin-top: 1rem;\n  }\n  \n  .custom-view-details-btn:hover {\n    background-color: var(--clr-primary-3);\n    transform: translateY(-2px);\n  }\n  \n/* Close Icon Container */\n.custom-close-icon-container {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    background-color: var(--grey-400); \n    border-radius: 50%; \n    width: 40px; \n    height: 40px; \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); \n}\n\n/* Icon itself */\n.custom-close-icon {\n    font-size: 1.5rem;\n    color: var(--clr-grey-5); /* Icon color */\n    transition: color 0.3s ease-in-out, transform 0.3s ease-in-out;\n}\n\n/* Hover Effect */\n.custom-close-icon-container:hover {\n    background-color: var(--clr-primary-3); \n    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15); \n}\n\n.custom-close-icon-container:hover .custom-close-icon {\n    color: var(--clr-white); \n    transform: rotate(90deg); \n}\n\n.textarea-wrapper {\n    display: flex;\n    align-items: center; \n    gap: 10px; \n}\n\n.textarea-wrapper textarea {\n    width: 100%; \n    height: 80px;\n    border: 1px solid var(--clr-grey-3);\n    border-radius: 8px;\n    padding: 1rem;\n    font-size: 1rem;\n    resize: vertical;\n}\n\n.textarea-wrapper .mic-button {\n    cursor: pointer;\n    background: none;\n    border: none;\n    font-size: 1.2rem; \n    padding: 0; \n}\n\n.textarea-wrapper .mic-button.listening {\n    color: #ff5722; \n}\n\n.textarea-wrapper .mic-button.stop-button {\n    color: #F44336; \n}\n\n.textarea-wrapper .mic-button.disabled-mic {\n    color: #b0b0b0; \n    cursor: not-allowed;\n}\n\n/* Ensure the icon buttons are vertically centered */\n.mic-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%; \n}\n\n/* Status-specific overrides */\n.custom-status-badge.BO {\n    background: linear-gradient(135deg, #e07a5f, #b95441); /* Coral-Orange */\n    color: white;\n  }\n  \n  .custom-status-badge.AP {\n    background: linear-gradient(135deg, #fdd835, #fbc02d); /* Amber */\n    color: #2c2c2c;\n  }\n  \n  .custom-status-badge.PW {\n    background: linear-gradient(135deg, #42a5f5, #1e88e5); /* Blue */\n    color: white;\n  }\n  \n  .custom-status-badge.CO {\n    background: linear-gradient(135deg, #66bb6a, #43a047); /* Green */\n    color: white;\n  }\n  \n  .custom-status-badge.CA {\n    background: linear-gradient(135deg, #ef5350, #e53935); /* Red */\n    color: white;\n  }\n  \n  .custom-status-badge.PC {\n    background: linear-gradient(135deg, #7e57c2, #5e35b1); /* Purple */\n    color: white;\n  }\n  \n  @media (max-width: 480px) {\n    .custom-status-badge {\n      font-size: 0.75rem;\n      padding: 0.3rem 0.6rem;\n    }\n  }\n  \n.error-message-complete {\n    color: red;\n    font-size: 12px;\n    margin-top: 4px;\n  }\n  \n  .error-border {\n    border: 2px solid red !important;\n  }\n\n  .intake-form-info-wrapper {\n    margin-top: 1.5rem;\n    padding: 1rem;\n    background-color: var(--clr-grey-10);\n    border: 1px solid var(--clr-grey-5);\n    border-radius: 8px;\n    text-align: center;\n  }\n  \n  .intake-form-info-text {\n    font-size: 1rem;\n    color: var(--clr-grey-3);\n    margin-bottom: 0.75rem;\n  }\n  \n  .custom-intake-form-btn {\n    padding: 0.6rem 1.2rem;\n    background-color: var(--clr-primary-6);\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .custom-intake-form-btn:hover {\n    background-color: var(--clr-primary-7);\n  }\n  \n\n  .summary-section-wrapper {\n    margin-top: 1.5rem;\n    padding: 1rem;\n    border: 1px solid var(--clr-primary-4);\n    border-radius: 8px;\n    background-color: var(--clr-grey-10);\n    font-size: 0.95rem;\n  }\n  \n  .summary-title {\n    margin-bottom: 0.75rem;\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--clr-grey-1, #333);\n  }\n  \n  .summary-field {\n    margin-bottom: 0.75rem;\n  }\n  \n  .summary-input,\n  .summary-textarea {\n    width: 100%;\n    font-size: 0.9rem;\n    padding: 0.4rem 0.6rem;\n    border: 1px solid var(--clr-grey-3);\n    border-radius: 6px;\n    resize: vertical;\n    background-color: white;\n  }\n  \n  .summary-textarea {\n    min-height: 60px;\n  }\n  \n  .room-highlight-badge {\n    background-color: #fdd835; /* Amber yellow */\n    color: #000; /* Dark text for contrast */\n    padding: 2px 8px;\n    border-radius: 8px;\n    font-weight: bold;\n    display: inline-block;\n    margin-left: 4px;\n  }\n  \n  .timeline-cta-box {\n    margin-top: 1rem;\n    background-color: var(--clr-primary-9);\n    padding: 0.75rem 1rem;\n    border-radius: var(--radius);\n    border: 1px solid var(--clr-grey-8);\n  }\n  \n  .timeline-cta-text {\n    font-size: 0.95rem;\n    color: var(--clr-grey-1);\n  }\n  \n  .timeline-cta-link {\n    color: var(--clr-primary-7);\n    font-weight: bold;\n    cursor: pointer;\n    text-decoration: underline;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
